<template>
  <div class="chart">
    <div class="chart__grid">
      <div class="chart__grid__items">
        <TimeControlCardChartItem
          v-for="(work, index) in works"
          :key="index"
          :work="work"
          :mathMaxWorkSize="mathMaxWorkSize"
        />
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TimeControlCardChartItem from './TimeControlCardChartItem'
export default {
  name: 'TimeControlCardChart',
  props: ['works'],
  components: { TimeControlCardChartItem },
  data() {
    return {}
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    mathMaxWorkSize() {
      let maxSize = this.works
        .map((item) => (item.done > item.planned ? item.done : item.planned))
        .filter((value, index, self) => self.indexOf(value) === index)
      return Math.max(...maxSize)
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  display: grid;
  // height: 100%;
  &__grid {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    height: inherit;
    &__items {
      width: 100%;
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      column-gap: 20px;
      justify-content: center;
      padding: 16px;
      min-height: inherit;
      align-items: flex-end;
      &--extra {
        background-color: #f4f4f4;
        border-left: 1px dashed #909090;
      }
    }
    hr {
      position: absolute;
      width: 99%;
      bottom: 38px;
      z-index: 0;
      background: #2c2c2c;
    }
  }
}
</style>
